import { CAMPAIGN_ERRORS } from "../common/constants/campaignModule/campaignConstant";
import { CAMPAIGN_URLS } from "./apiConfig";
import apiClient from "./apiInstance";

// update the Campaign
// update the Campaign
export const updateCampaign = async (campaignID, updatedData) => {
  try {
    const response = await apiClient.post(
      CAMPAIGN_URLS.UPDATE_CAMPAIGN,
      {
        campaignID,
        name: updatedData.name,
        description: updatedData.description,
        useAI: updatedData.useAI,
        category: updatedData.category,
        language: updatedData.language,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    console.error(CAMPAIGN_ERRORS.UPDATE_CAMPAIGN_ERROR, error);
    throw error;
  }
};

  export const getCampaigns = async () => {
    try {
      const response = await apiClient.get(CAMPAIGN_URLS.FETCH_CAMPAIGN);
      return response.data;
    } catch (error) {
      console.error(CAMPAIGN_ERRORS.FETCH_CAMPAIGN_ERROR, error);
      throw error;
    }
  }

  
  export const getProcesses = async () => {
    try {
      const response = await apiClient.get(CAMPAIGN_URLS.FETCH_PROCESS);
      return response.data;
    } catch (error) {
      console.error(CAMPAIGN_ERRORS.FETCH_PROCESS_ERROR, error);
      throw error;
    }
  }